import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import analyticDataStore, {
  IBaseAnalyticsCombined,
} from "@/store/analyticsDataStore";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import DateRangeAndSlider from "../ClientSummaryReport/DateRangeAndSlider";
import CurrencyAndInstrumentFilters from "../CurrencyAndInstrumentFilters";
import {
  filterByDatesTimeSent,
  filterDataGeneric,
} from "../analyticsHelperFunctions";
import BarComboTransactionCost from "./BarComboTransactionCost";
import TransactionCostCurrency from "./Tables/TransactionCostCurrency";
import TransactionCostAllData from "./Tables/TransactionCostAllData";

// export interface ITransactionCost {
//   tradeDate: Date; // Date
//   securityType: string;
//   security: string;
//   trader: string;
//   direction: string;
//   currency: string;
//   mid: number;
//   cover: number;
//   dv01: number;
//   spreadToMid: number;
//   bidOffer: number;
//   tradeCostVsMid: number;
// }

export interface ITransactionCostFilters {
  range: number[];
  selectedCurrencies: string[];
  selectedInstruments: string[];
  selectedSecurities: string[];
}

export const baseFilterTransactionCost = {
  range: [],
  selectedCurrencies: [],
  selectedInstruments: [],
  selectedSecurities: [],
};

function buildFilteredData(
  data: IBaseAnalyticsCombined[],
  dataFilters: ITransactionCostFilters,
): IBaseAnalyticsCombined[] {
  if (!data || data.length == 0) {
    return [];
  }
  const filterByStatus = data.filter(
    (item) => item.lastAction == ExecutionStrategyStatus.Affirmed,
  );
  const filteredByDates = filterByDatesTimeSent(filterByStatus, dataFilters);

  const activeFilters = {
    currency: dataFilters.selectedCurrencies,
    instrumentType: dataFilters.selectedInstruments,
    securityType: dataFilters.selectedSecurities,
  };

  const multiFilterResult = filterDataGeneric(filteredByDates, activeFilters);

  return multiFilterResult;
}

const TransactionCostIndex = () => {
  const { theme } = useTheme();
  const analyticsZustand = analyticDataStore((state) => state.analyticData);

  const [data, setData] = useState<IBaseAnalyticsCombined[]>(analyticsZustand);

  useEffect(() => {
    setData(analyticsZustand);
  }, [analyticsZustand]);

  const [dataFilters, setDataFilters] = useState<ITransactionCostFilters>(
    baseFilterTransactionCost,
  );

  const [filteredData, setFilteredData] = useState<IBaseAnalyticsCombined[]>(
    buildFilteredData(data, dataFilters),
  );

  useEffect(() => {
    setFilteredData(buildFilteredData(data, dataFilters));
  }, [data, dataFilters]);

  return (
    <div data-testid="CounterpartyReportIndex" className="h-full w-full p-1">
      <div className="flex h-full w-full gap-2">
        <div className="flex h-full min-w-[230px] flex-col gap-2 ">
          {/* TOP SQUARE */}
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} mr-2 h-[60%] w-full overflow-hidden p-2`}
          >
            <div className="h-full w-full ">
              <div
                data-testid="DateRangeAndSliderContainer"
                className="flex h-full w-full flex-col "
              >
                <DateRangeAndSlider
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                  isSecondary={false}
                />
                {/* Filter toggles */}
                <CurrencyAndInstrumentFilters
                  data={data}
                  dataFilters={dataFilters}
                  setDataFilters={setDataFilters}
                />
              </div>
            </div>
          </div>
          {/* Second square */}
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"}  h-[40%] w-[calc(100%+20rem)] p-2 `}
          >
            <TransactionCostCurrency
              data={data}
              filteredData={filteredData}
              dataFilters={dataFilters}
              setDataFilters={setDataFilters}
            />
          </div>
        </div>
        {/* Responsive section of widget frame - will expand and contract as requierd. */}
        {/* Main chart */}
        <div className="flex h-full w-full flex-col items-end gap-2  ">
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} flex h-[60%] w-full overflow-hidden p-2`}
          >
            <BarComboTransactionCost filteredData={filteredData} />
          </div>
          <div
            className={`${theme == "dark" ? "agChartCubeBorderDark" : "agChartCubeBorder"} h-[40%] w-[calc(100%-20rem)]  p-2`}
          >
            <TransactionCostAllData
              filteredData={filteredData}
              dataFilters={dataFilters}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionCostIndex;
